import { ForwardedRef, forwardRef } from 'react';
import { FieldError, FieldErrorsImpl, Merge } from 'react-hook-form';

import {
  Flex,
  FormControl,
  FormErrorMessage,
  FormHelperText,
  FormLabel,
  Input,
  InputProps,
  Tooltip,
} from '@chakra-ui/react';
import { InfoIcon, WarningIcon } from '@udacity/chakra-uds-icons';

type Props = InputProps & {
  label: string;
  helperText?: string;
  infoText?: string;
  errorMessage?: string | FieldError | Merge<FieldError, FieldErrorsImpl<object>> | undefined;
  isDisabled?: boolean;
};

function TextInput(props: Props, ref: ForwardedRef<HTMLInputElement>) {
  const { label, errorMessage, helperText, infoText, isDisabled, ...inputProps } = props;

  return (
    <FormControl isDisabled={isDisabled} isInvalid={Boolean(errorMessage)}>
      <Flex>
        <FormLabel mb={helperText ? 0 : '8px'} data-peer>
          {label}
        </FormLabel>
        {infoText && (
          <Tooltip label={infoText} hasArrow>
            <InfoIcon color='black' height='24px' width='24px' />
          </Tooltip>
        )}
      </Flex>
      {helperText && <FormHelperText margin='0 0 8px 0'>{helperText}</FormHelperText>}
      <Input ref={ref} {...inputProps} />
      {errorMessage && (
        <FormErrorMessage mt='8px'>
          <>
            <WarningIcon h='26px' w='26px' />
            {errorMessage}
          </>
        </FormErrorMessage>
      )}
    </FormControl>
  );
}

export const FormTextInput = forwardRef(TextInput);
